<app-nav></app-nav>

<main class="lr-page">

  <!-- HERO (background image: src/assets/live/live-hero.jpg) -->
  <section class="lr-hero" [style.background-image]="'url(assets/live/hero-bg.jpg)'">
    <div class="lr-hero-text">
      <h1>UMYO <span>Live Chat</span></h1>
      <p>Real People. Real Conversations. Real Opportunities.</p>
    </div>
    <div class="lr-hero-quote">
      <b>Your Voice<br />Builds Community</b>
      <em>Let's Talk!</em>
    </div>
    <a class="lr-start" routerLink="/go-live"><i class="fa-solid fa-plus"></i> Start a Live Room</a>
  </section>

  <section class="lr-bar">
    <div class="lr-tabs">
      <button type="button" [class.active]="tab === 'live'" (click)="tab = 'live'">
        <i class="fa-solid fa-tower-broadcast"></i> Live Now
      </button>
      <button type="button" [class.active]="tab === 'mine'" (click)="tab = 'mine'">
        <i class="fa-solid fa-door-open"></i> My Rooms
      </button>
    </div>
    <div class="lr-search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="search" placeholder="Search live chat rooms..." [(ngModel)]="search" autocomplete="off" />
    </div>
  </section>

  <section class="lr-layout">

    <!-- LEFT: rooms + stage -->
    <div class="lr-left">

      <div class="lr-panel">
        <h2>Featured Live Rooms <small>{{ filtered.length }} live</small></h2>

        <div class="lr-cards" *ngIf="filtered.length">
          <button type="button" class="lr-card" *ngFor="let s of filtered; trackBy: trackByToken"
                  [class.sel]="selected?.token === s.token" (click)="watch(s)">
            <span class="lr-thumb">
              <img [src]="photo(s.user)" (error)="onImgError($event)" alt="" />
              <span class="lr-badge"><i class="lr-dot"></i> LIVE</span>
            </span>
            <span class="lr-cinfo">
              <b>{{ fullName(s.user) }}</b>
              <small>{{ sub(s.user) || liveFor(s) }}</small>
              <span class="lr-watch">{{ selected?.token === s.token ? 'Watching' : (s.user?.id == myId ? 'Your room' : 'Watch') }}</span>
            </span>
          </button>
        </div>

        <div class="lr-spin" *ngIf="loadingList"><div class="lr-spinner"></div></div>
        <p class="lr-empty" *ngIf="!loadingList && !filtered.length && !listError">
          {{ tab === 'mine' ? 'You are not live right now.' : 'No live rooms right now.' }}
        </p>
        <p class="lr-empty bad" *ngIf="listError">{{ listError }}</p>
      </div>

      <div class="lr-panel">
        <div class="lr-frame" #frame>
          <div class="lr-stage" #stage></div>

          <div class="lr-top" *ngIf="selected && !ownRoom && !stageMsg">
            <span class="lr-badge"><i class="lr-dot"></i> LIVE</span>
            <span class="lr-view"><i class="fa-solid fa-eye"></i> {{ viewers }}</span>
          </div>

          <div class="lr-overlay" *ngIf="stageMsg">
            <i class="fa-solid" [ngClass]="connecting ? 'fa-circle-notch fa-spin' : 'fa-tower-broadcast'"></i>
            <span>{{ stageMsg }}</span>
          </div>

          <button type="button" class="lr-sound" *ngIf="audioBlocked" (click)="enableSound()">
            <i class="fa-solid fa-volume-high"></i> Tap to enable sound
          </button>
        </div>

        <div class="lr-host" *ngIf="selected">
          <img [src]="photo(selected.user)" (error)="onImgError($event)" class="lr-hav" alt="" />
          <div class="lr-hwho">
            <b>{{ fullName(selected.user) }}</b>
            <small>{{ sub(selected.user) || liveFor(selected) }}</small>
          </div>
          <div class="lr-ctrl">
            <button type="button" title="Fullscreen" (click)="fullscreen()"><i class="fa-solid fa-expand"></i></button>
            <button type="button" title="Sound on / off" (click)="toggleSound()" [class.off]="muted">
              <i class="fa-solid" [ngClass]="muted ? 'fa-volume-xmark' : 'fa-volume-high'"></i>
            </button>
            <button type="button" class="end" title="Leave room" (click)="leave()"><i class="fa-solid fa-xmark"></i></button>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT: chat / participants / info -->
    <aside class="lr-right">
      <div class="lr-panel lr-side">

        <div class="lr-stabs">
          <button type="button" [class.active]="side === 'chat'" (click)="side = 'chat'">Live Chat</button>
          <button type="button" [class.active]="side === 'people'" (click)="side = 'people'">
            Participants ({{ totalPeople }})
          </button>
          <button type="button" [class.active]="side === 'info'" (click)="side = 'info'">Info</button>
        </div>

        <!-- chat -->
        <ng-container *ngIf="side === 'chat'">
          <div class="lr-msgs" #chatBox>
            <p class="lr-empty" *ngIf="!canChat && !chat.length">Join a live room to chat.</p>
            <p class="lr-empty" *ngIf="canChat && !chat.length">No messages yet. Say hello!</p>

            <div class="lr-msg" *ngFor="let m of chat" [class.mine]="m.mine">
              <span class="lr-mav">{{ m.name.charAt(0) }}</span>
              <div class="lr-bub">
                <b>{{ m.mine ? 'You' : m.name }}</b>
                <span>{{ m.text }}</span>
              </div>
              <time>{{ m.time | date : 'shortTime' }}</time>
            </div>
          </div>

          <p class="lr-chaterr" *ngIf="chatError">{{ chatError }}</p>

          <div class="lr-composer">
            <input [(ngModel)]="newMsg" (keyup.enter)="sendChat()" placeholder="Type a message..."
                   maxlength="300" autocomplete="off" [disabled]="!canChat" />
            <button type="button" class="lr-send" (click)="sendChat()" [disabled]="!canChat || !newMsg.trim()">
              <i class="fa-solid fa-paper-plane"></i>
            </button>
          </div>
        </ng-container>

        <!-- participants -->
        <div class="lr-list" *ngIf="side === 'people'">
          <p class="lr-empty" *ngIf="!selected || ownRoom || !room">Join a live room to see participants.</p>
          <ng-container *ngIf="selected && !ownRoom && room">
            <div class="lr-person" *ngIf="hostOnline">
              <span class="lr-mav">{{ fullName(selected.user).charAt(0) }}</span>
              <b>{{ fullName(selected.user) }}</b><span class="lr-tag">Host</span>
            </div>
            <div class="lr-person">
              <span class="lr-mav">{{ (myName || 'Y').charAt(0) }}</span>
              <b>{{ myName || 'You' }}</b><span class="lr-tag">You</span>
            </div>
            <div class="lr-person" *ngFor="let p of people">
              <span class="lr-mav">{{ (p.name || 'G').charAt(0) }}</span>
              <b>{{ p.name || 'Guest viewer' }}</b>
            </div>
          </ng-container>
        </div>

        <!-- info -->
        <div class="lr-list" *ngIf="side === 'info'">
          <p class="lr-empty" *ngIf="!selected">Select a live room to see details.</p>
          <ng-container *ngIf="selected">
            <div class="lr-info">
              <img [src]="photo(selected.user)" (error)="onImgError($event)" alt="" />
              <h3>{{ fullName(selected.user) }}</h3>
              <small>{{ sub(selected.user) }}</small>
              <span class="lr-tag">{{ liveFor(selected) }}</span>
            </div>
            <label class="lr-linklabel">Share link</label>
            <div class="lr-linkrow">
              <input type="text" [value]="link" readonly />
              <button type="button" (click)="copyLink()">
                <i class="fa-regular" [ngClass]="copied ? 'fa-circle-check' : 'fa-copy'"></i>
              </button>
            </div>
          </ng-container>
        </div>

      </div>
    </aside>

  </section>
</main>
